<script>
export default {
  name: 'ScaleAdjuster',
  data(){
    return{
      scaleMultiplier: 1,
    }
  },
  mounted(){
  },
  methods:{
    //Ajouter la valeur du coeff sélectionné dans le store (puisque mais éléments interdépendants sont parfois dans la même vue, parfois dans des vue différentes, je passe par le store à chaque fois)
  }
}
</script>


<template>
  <div class="scaleAdjuster">
    <div class="scaleAdjuster__title">Ajustement de l'échelle des valeurs</div>
    <input type="range" min="1" max="100" class="scaleAdjuster__slider" v-model='scaleMultiplier' @change="$emit('adjustement', scaleMultiplier)">
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.scaleAdjuster{
  @include myBlock;
  padding: 15px;
  display: inline-grid;
  &__title{
    @include myFont;
    color: $main;
    font-size: 13px;
    font-weight: 600;
    margin: 0 0 10px 0;
  }
  &__slider{
    align-items: center;
  }
}

</style>
